const { TriggerOnceEvents } = require('@flowio/events');
const find = require('lodash/find');

const constants = {
  BLAZE_ADD_PAYMENT_INFO: 'blaze.addPaymentInfo',
  BLAZE_PURCHASE: 'blaze.purchase',
  BLAZE_ADD_SHIPPING_INFO: 'blaze.addShippingInfo',
  BLAZE_BEGIN_CHECKOUT: 'blaze.beginCheckout',
  BLAZE_SELECT_PROMOTION: 'blaze.selectPromotion',
  BLAZE_CHECKOUT_COMPLETE: 'blaze.checkoutComplete',
  BLAZE_CHECKOUT_PROGRESS: 'blaze.checkoutProgress',
  BLAZE_ENTER_CHECKOUT: 'blaze.enterCheckout',
  BLAZE_EXIT_CHECKOUT: 'blaze.exitCheckout',
  READY: 'ready',
  ERROR: 'error',
  LOADED: 'loaded',
  BROWSER_BUNDLE_DATA: 'browser_bundle_data',
  BROWSER_BUNDLE_FAILURE: 'browser_bundle_failure',
  CART_ADD_ITEM: 'cart.addItem',
  CART_ADD_ITEMS: 'cart.addItems',
  CART_UPDATED: 'cart.updated',
  CART_REMOVE_ITEM: 'cart.removeItem',
  CART_UPDATE_ITEM: 'cart.updateItem',
  CART_CLEAR: 'cart.clear',
  CART_HTML: 'cart.html',
  WILL_LOCALIZE_CART: 'cart.will.localize',
  CART_ITEM_PRICES_LOCALIZED: 'cart.item.price.localized',
  CART_SUMMARY_PRICES_LOCALIZED: 'cart.summary.prices.localized',
  CART_LOCALIZED: 'cart.localized',
  PAGEVIEW_COLLECTION: 'pageview.collection',
  PAGEVIEW_PRODUCT_DETAIL: 'pageview.product_detail',
  PAGEVIEW_CART: 'pageview.cart',
  PAGEVIEW_CHECKOUT_STEP_1: 'pageview.checkout_step_1',
  PAGEVIEW_CHECKOUT_STEP_2: 'pageview.checkout_step_2',
  PAGEVIEW_CHECKOUT_STEP_3: 'pageview.checkout_step_3',
  PAGEVIEW_CHECKOUT_THANK_YOU: 'pageview.checkout_thank_you',
  FEATURES_LOCALIZED: 'features.localized',
  CHECKOUT_REDIRECT: 'checkout.redirect',
};

const {
  BLAZE_ADD_PAYMENT_INFO,
  BLAZE_PURCHASE, BLAZE_ADD_SHIPPING_INFO,
  BLAZE_BEGIN_CHECKOUT, BLAZE_SELECT_PROMOTION,
} = constants;

/**
 * Events that are only triggered once by the page. Used to auto execute
 * callbacks for events in this list
 * @type {Array}
 */
const triggerOnceEvents = [
  constants.READY,
  constants.LOADED,
  constants.PAGEVIEW_COLLECTION,
  constants.PAGEVIEW_PRODUCT_DETAIL,
  constants.BROWSER_BUNDLE_DATA,
  constants.BROWSER_BUNDLE_FAILURE,
];

const shopifyJsEvents = new TriggerOnceEvents({ triggerOnceEvents });

/**
 * Checkout pages are not represented here, the app will trigger them manually via:
 * `Flow.triggerEvent(Flow.events.constants.PAGEVIEW_CHECKOUT_STEP_1)`
 *
 * @type {Array}
 */
const pageRegexes = [
  {
    pageType: constants.PAGEVIEW_COLLECTION,
    regex: /^\/collections\/[^\/]+$/,
  },
  {
    pageType: constants.PAGEVIEW_PRODUCT_DETAIL,
    regex: /^(\/collections\/[^\/]+)?\/products(\/.*)?$/,
  },
  {
    pageType: constants.PAGEVIEW_CART,
    regex: /^\/cart$/,
  },
];

function getPageType(pathname) {
  const matchingRegex = find(pageRegexes, pageRegex => pageRegex.regex.test(pathname));

  if (matchingRegex) {
    return matchingRegex.pageType;
  }

  return undefined;
}

function on(key, callback) {
  shopifyJsEvents.on(key, callback);
}

/**
 * Trigger event when Browser Bundle is loaded
 *
 * @param {BrowserBundle} bundle  The browser bundle response payload
 */
function triggerBrowserBundleEvent(bundle) {
  shopifyJsEvents.trigger(constants.BROWSER_BUNDLE_DATA, bundle);
}

/**
 * Trigger shopify page view events based on the pathname of the current url.
 *
 * pathname defaults to window.location.pathname.
 *
 * @param  {string} [pathname] Optional. pathname to use to determine which type of page it is
 */
function triggerPageViewEvent(pathname) {
  const pageType = getPageType(pathname || window.location.pathname);
  if (pageType) {
    shopifyJsEvents.trigger(pageType);
  }
}

/**
 * Trigger an event. Check if the event is configured to only be triggered once
 * per page view. If so, don't actually trigger event. Any new callbacks
 * registered to triggerOnce events will be triggered automatically if it has
 * been triggered already.
 *
 * @param  {string} key  Event key from `constants`
 * @param  {Mixed} [data] The data to send when triggering event
 */
function trigger(key, data) {
  shopifyJsEvents.trigger(key, data);
}

const blazeCheckoutEvents = (message) => {
  switch (message.event_type) {
  case 'add_payment_info':
    trigger(BLAZE_ADD_PAYMENT_INFO, message);
    break;
  case 'purchase':
    trigger(BLAZE_PURCHASE, message);
    break;
  case 'add_shipping_info':
    trigger(BLAZE_ADD_SHIPPING_INFO, message);
    break;
  case 'begin_checkout':
    trigger(BLAZE_BEGIN_CHECKOUT, message);
    break;
  case 'select_promotion':
    trigger(BLAZE_SELECT_PROMOTION, message);
    break;
  default:
    break;
  }
};

/**
 * Reset the list of prevously triggered events. For use by single page apps
 * when user navigates to a new page.
 */
function resetPreviouslyTriggered() {
  shopifyJsEvents.resetPreviouslyTriggered();
}

function triggerLoadedEvent() {
  shopifyJsEvents.trigger(constants.LOADED);
}

function triggerReady() {
  shopifyJsEvents.trigger(constants.READY);
}

function off(event, listener) {
  shopifyJsEvents.emitter.off(event, listener);
}

function once(event, listener) {
  shopifyJsEvents.emitter.once(event, listener);
}

function removeAll(event) {
  shopifyJsEvents.emitter.removeAll(event);
}

module.exports = {
  on,
  off,
  once,
  removeAll,
  blazeCheckoutEvents,
  constants,
  trigger,
  triggerBrowserBundleEvent,
  triggerReady,
  triggerPageViewEvent,
  triggerLoadedEvent,
  resetPreviouslyTriggered,
};



// WEBPACK FOOTER //
// ./static/js/v0/events.js